module.exports = __webpack_public_path__ + "static/media/toalett.2d724c6e.svg";